import $ from 'jquery';
import 'select2';

function templateResult(data) {
    // We only really care if there is an element to pull classes from
    if (!data.element) {
        return data.text;
    }

    const $element = $(data.element);
    const $wrapper = $('<span></span>');
    $wrapper.addClass($element[0].className);
    $wrapper.text(data.text);
    return $wrapper;
}

function filter(i, elem) {
    return $(elem).closest('.ibe-wrapper').length === 0;
}

$('select:not(.no-select2):not(.with-search)').filter(filter).select2({
    width: '100%',
    minimumResultsForSearch: -1,
    templateResult: templateResult,
}).trigger('change');

$('select.with-search:not(.no-select2)').filter(filter).select2({
    width: '100%',
    minimumResultsForSearch: 1,
    templateResult: templateResult,
}).trigger('change');

$('select.multi-select:not(.no-select2)').filter(filter).select2({
    width: '100%',
    minimumResultsForSearch: -1,
    templateResult: templateResult,
    multiple: true,
    allowClear: true,
}).val('').trigger('change');

$('select.select-link').on('change', function () {
    let a = document.createElement('a');
    a.href = $(this).val();
    a.click();
});
